import React from "react";
import "./Footer.scss";
import DisclaimerComponent from "@zappy-ride/disclaimer-footer-component";

import logo from "../../../assets/images/logoFooter.svg";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="top-row">
        <div>
          <a
            href="https://dasher.doordash.com/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="doordash logo" />
          </a>
          <a
            href="https://dasher.doordash.com/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            Become a Dasher
          </a>
        </div>
      </div>
      <div
        className="container pt-5 pb-4 "
        style={{ maxWidth: "1224px", padding: "60px 0 32px" }}
      >
        <div className="row footer">
          <div className="footer-text col-sm-12 d-flex justify-content-between align-items-end">
            <div className="d-flex justify-content-end w-100">
              <span style={{ textAlign: 'right' }}>
                <a href="https://help.doordash.com/dashers/s/ica-us">Terms</a>
                {' | '}
                <a href="https://help.doordash.com/dashers/s/privacy-policy-us">Privacy</a>
              </span>
            </div>
          </div>
          {/* <div className="footer-text col-sm-12" style={{ textAlign: "right" }}>
            
            <span>© 2022 DoorDash</span>
          </div> */}
          <div className="footer-text col-sm-12" style={{ textAlign: "right" }}>
            {/* <span>
              {" "}
              &copy;
              {new Date().getFullYear().toString() + " "} J.D. Power ZappyRide (c).{" "}
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://zappyride.com/legal-notices"
              >
                Legal notices.
              </a>
            </span> */}

            <span className="disclaimer_container">
              <DisclaimerComponent
                clientName="Doordash"
                backgroundColor={"#191919"}
                fontColor={"#FFFFFF"}
                imageStyle={{
                  marginTop: "-30px",
                  color: "#FFFFF",
                  display: "none",
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
